<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn  btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
          </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "schedules",
    cardSetLink: "schedules",
    item: null,
    fields: [
      {
          key: "position",
          label: "Номер урока",
          type: "field",
          textType: "text",
        },
        {
          col:'col-12 col-md-6',
          key: "from_at",
          label: "Начало урока",
          type: "mask",
          mask: "##:##",
          placeholder:'--:--'
        },
        {
          col:'col-12 col-md-6',
          key: "till_at",
          label: "Окончание урока",
          type: "mask",
          mask: "##:##",
          placeholder:'--:--'
        },
      ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
